import { getBackendUrl } from "../config";

const defaultBranding = {
  logoUrl: "/logo.png",
  faviconUrl: "/favicon.ico",
  siteTitle: "CRM Multiagente",
  widgetTitle: "Interno",
  widgetPoweredName: "Kodelr",
  widgetPoweredUrl: "https://kodelr.com",
  landingEmbedUrl: "",
  loginHeadline: "Centraliza tus conversaciones y convierte mas rapido",
  loginSubtitle:
    "Gestiona WhatsApp, equipos, seguimientos y automatizaciones desde un solo espacio.",
  loginPrimaryLinkLabel: "Solicitar demo",
  loginPrimaryLinkUrl: "",
  loginSecondaryLinkLabel: "Soporte",
  loginSecondaryLinkUrl: "",
  loginLinks: JSON.stringify([
    { label: "Solicitar demo", url: "" },
    { label: "Soporte", url: "" },
  ]),
  loginSlides: JSON.stringify([
    {
      imageUrl:
        "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1400&q=80",
      title: "Atencion organizada",
      description: "Conserva cada conversacion, responsable y seguimiento en contexto.",
    },
    {
      imageUrl:
        "https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&w=1400&q=80",
      title: "Equipos conectados",
      description: "Administra conversaciones, areas y automatizaciones sin perder visibilidad.",
    },
    {
      imageUrl:
        "https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=1400&q=80",
      title: "Seguimiento claro",
      description: "Haz que cada oportunidad avance con recordatorios y secuencias.",
    },
  ]),
};

export const resolveBrandingUrl = url => {
  if (!url) return "";
  if (/^https?:\/\//i.test(url) || url.startsWith("data:")) return url;

  if (url.startsWith("/public/")) {
    const backendUrl = (getBackendUrl() || "").replace(/\/+$/, "");
    return backendUrl ? `${backendUrl}${url}` : url;
  }

  return url;
};

export const getCachedBranding = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem("siteBranding") || "{}");
    return { ...defaultBranding, ...parsed };
  } catch {
    return defaultBranding;
  }
};

const setDocumentBranding = branding => {
  document.title = branding.siteTitle ?? "";

  const faviconUrl = resolveBrandingUrl(branding.faviconUrl || "data:,");
  const links = document.querySelectorAll("link[rel*='icon']");
  const faviconLink =
    links[0] ||
    Object.assign(document.createElement("link"), { rel: "icon" });

  faviconLink.href = faviconUrl;
  if (!faviconLink.parentNode) {
    document.head.appendChild(faviconLink);
  }

  links.forEach(link => {
    link.href = faviconUrl;
  });
};

export const applyBranding = branding => {
  const nextBranding = { ...defaultBranding, ...(branding || {}) };
  localStorage.setItem("siteBranding", JSON.stringify(nextBranding));
  setDocumentBranding(nextBranding);

  window.dispatchEvent(
    new CustomEvent("brandingChanged", { detail: nextBranding })
  );

  return nextBranding;
};

export const applyResellerBranding = resellerBranding => {
  const nextBranding = {
    logoUrl: resellerBranding?.logoUrl || "",
    faviconUrl: resellerBranding?.faviconUrl || resellerBranding?.logoUrl || "data:,",
    siteTitle: resellerBranding?.title || resellerBranding?.brandName || resellerBranding?.name || "",
  };

  setDocumentBranding(nextBranding);

  window.dispatchEvent(
    new CustomEvent("brandingChanged", { detail: nextBranding })
  );

  return nextBranding;
};

export default defaultBranding;
